import React, { Fragment, ReactElement } from 'react';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from './configuration';
import { Button, Typography } from '@material-ui/core';
import useStyles from './styles';
import AddIcon from '@material-ui/icons/Add';
import DatatableList from './components/datatable';
import { useDispatch } from 'react-redux';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import * as VatReturnDetailsSelectors from 'redux/reducers/vatReturn_detail_reducer/selectors';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';
import VatReturnDetailActions from 'redux/reducers/vatReturn_detail_reducer/actions';
import { StateStatus } from 'redux/utils/common';
import * as DateUtils from 'utils/dates';
import Totals from './components/total_vat_amount';

// START COUNTRY INTERFACES
interface ICountry {
  country_id: number;
  country: string;
  vat_rate: Array<ICountryVatRate>;
}

interface ICountryVatRate {
  vat_rate_id: number;
  vat_rate_type_id: number;
  vat_rate: number;
  vat_rate_type: string;
}

interface ICountriesWithVatRate {
  data: Array<ICountry>;
  status: StateStatus;
}
// END COUNTRY INTERFACES

// START SUPPLIES FROM FIXED ESTABLISHMENTS INTERFACES
interface ISuppliesFromFixedEstablishments {
  vat_return_supply_id: number;
  supply_type: string;
  supply_type_id: number;
  consumer_id: number;
  consumer: string;
  vat_rate_id: number;
  vat_rate: number;
  vat_rate_type: string;
  taxable_amount: number;
  vat_amount: number;
  fixed_establishment: number;
}

interface ISuppliesFromFixedEstablishmentOutput {
  items: Array<ISuppliesFromFixedEstablishments>;
  total_vat_amount_payable_services: number;
  total_vat_amount_payable_goods: number;
}
// END SUPPLIES FROM FIXED ESTABLISHMENTS INTERFACES

interface IProps {
  mode: 'VIEW' | 'EDIT';
  // countries: ICountriesWithVatRate;
  vat_number: string;
  vat_return_id: number;
  supplies: ISuppliesFromFixedEstablishmentOutput;
}

export default function SuppliesFromFixedEstablishments(
  props: IProps
): ReactElement {
  // console.log('Render SuppliesFromFixedEstablishments');
  const mode = props.mode;
  const supplies = props.supplies;
  const classes = useStyles();
  const dispatch = useDispatch();

  let ossScheme = getState(ReducerKeys.VATRETURN_DETAIL_REDUCER).vatReturnDetail
    .data.oss_scheme;
  const vatReturnDetail = VatReturnDetailsSelectors.useGetVatReturnDetail();
  const isNotEstablished =
    vatReturnDetail?.data?.nonUnionSchemeDetail?.notEstablished === true;

  React.useEffect(() => {
    dispatch(
      VatReturnDetailActions.setFixedEstablishmentsByVatReturn({
        vat_return_id: props.vat_return_id,
      })
    );
  }, [dispatch]);

  // const result = VatReturnDetailsSelectors.useGetSuppliesFromFixedEstablishment();
  const fixedEstablishments =
    VatReturnDetailsSelectors.useGetFixedEstablishmentsOfVatReturn();
  const countries = VatReturnDetailsSelectors.useGetCountriesWithVatRate();

  return (
    <Fragment>
      <div className={classes.header_container}>
        <Typography variant="h5">
          <TranslatedText textMap={Translations.header} />
        </Typography>
        {!isNotEstablished && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            disabled={
              mode === 'VIEW' ||
              !countries ||
              countries.status !== StateStatus.Success ||
              !fixedEstablishments ||
              fixedEstablishments.status != StateStatus.Success
            }
            onClick={() => {
              dispatch(
                ModalActions.openModalAction({
                  modalID: ModalIDs.MODAL_ADD_SUPPLY_FROM_FIXED_ESTABLISHMENTS,
                  params: {
                    vat_number: props.vat_number,
                    ossScheme: ossScheme,
                  },
                })
              );
            }}
          >
            <TranslatedText textMap={Translations.add_supply} />
          </Button>
        )}
      </div>
      <DatatableList mode={mode} data={supplies?.items || []} />
      <Totals
        totalVatAmountPayableGoods={
          supplies.total_vat_amount_payable_goods ?? 0
        }
        totalVatAmountPayableServices={
          supplies.total_vat_amount_payable_services ?? 0
        }
      />
    </Fragment>
  );
}
